// Code review - In Progress
// Documentation - In Progress
import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";
import { ImageAPI } from "../services/APIConnection";
import download from "../image/download.png";
import pdf from "../image/pdf.png";
import word from "../image/word_icon.png";
import excel from "../image/xls_icon.png";
import ppt from "../image/ppt_icon.png";

const FileUpload = (props) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showImage, setShowImage] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [cancelImage, setCancelImage] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(props.disabledBtn);
  const fileInputRef = useRef(null);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");

  const MAX_FILE_SIZE_MB = props.MAX_FILE_SIZE_MB;
  const ALLOWED_FORMATS = props.ALLOWED_FORMATS;

  const isImageFile = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
    const ext = url?.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(ext);
  };

  const getViewerUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();
    return extension === "pdf"
      ? url
      : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        url
      )}`;
  };

  const getFileIcon = (url) => {
    const ext = url?.split(".").pop()?.toLowerCase();
    switch (ext) {
      case "pdf":
        return pdf;
      case "doc":
      case "docx":
        return word;
      case "xls":
      case "xlsx":
        return excel;
      case "ppt":
      case "pptx":
        return ppt; // ✅ return PowerPoint icon
      default:
        return isImageFile(url) ? url : download;
    }
  };

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);
  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
    setButtonDisable(false);
    setShowImage(download);
    setSelectedFiles([]);
    const files = event.target.files;

    const selectedFilesLimited = Array.from(files)
      .filter((file) => isFileFormatAllowed(file) && isFileSizeBelowLimit(file))
      .slice(0, 3);

    if (selectedFiles.length + selectedFilesLimited.length > 3) {
      setUploadError("Cannot select more than 3 files");
      return;
    } else {
      setUploadError("");
    }

    setSelectedFiles((prevFiles) => [
      ...prevFiles,
      ...selectedFilesLimited.map((file) => ({
        file,
        previewUrl: URL.createObjectURL(file),
      })),
    ]);

    const unsupportedFormatFiles = Array.from(files).filter(
      (file) => !isFileFormatAllowed(file)
    );
    if (unsupportedFormatFiles.length > 0) {
      const unsupportedFilesNames = unsupportedFormatFiles
        .map((file) => file.name)
        .join(", ");
      setUploadError(`Unsupported file format: ${unsupportedFilesNames}`);
      return;
    }

    const oversizedFiles = Array.from(files).filter(
      (file) => !isFileSizeBelowLimit(file)
    );
    if (oversizedFiles.length > 0) {
      const errorMessage = `File size exceeds the limit (${MAX_FILE_SIZE_MB}MB)`;
      setUploadError(errorMessage);
      return;
    }
  };

  const handleUpload = async () => {

    if (props.clearImageUploadError) {
      props.clearImageUploadError();
    }
    setButtonDisable(true);
    setCancelImage(false);
    if (selectedFiles.length === 0) {
      setUploadError("Please select files to upload");
      if (props.onUploadStatus) {
      props.onUploadStatus(false, "Please select files to upload");
    }
      return;
    }

    const formData = new FormData();
    formData.append(props.modalName, selectedFiles[0].file);
    if (props.partnerId !== undefined && props.partnerId !== null) {
      formData.append("PartnerId", props.partnerId);
    }
    if (props.createdBy !== undefined && props.createdBy !== null) {
      formData.append("CreatedBy", props.createdBy);
    }

    try {
      const response = await ImageAPI(formData, props.apiCall);
      if (showImage) {
        if (typeof response.data === "string") {
          props.showImageData(response.data);
          setShowImage(response.data);
        } else if (
          typeof response.data === "object" &&
          response.data !== null
        ) {
          props.showImageData(response.data);
          setShowImage(response.data.fileUrl);
        }
      }
      setUploadError("");
       // ✅ Notify parent on success
    if (props.onUploadStatus) {
      props.onUploadStatus(true, "File uploaded successfully");
    }
    } catch (error) {
      console.error("Error uploading image:", error);
      setUploadError("Failed to upload image");
      //  Notify parent on failure
    if (props.onUploadStatus) {
      props.onUploadStatus(false, "File upload failed");
    }
    }
  };

  const handleCancel = () => {
    setSelectedFiles([]);
    setShowImage("");
    setUploadError("");
    setCancelImage(true);
    setButtonDisable(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (props.showImageData) {
      props.showImageData("");
    }
  };

  return (
    <div className={props.classDiv ? props.classDiv : mainTable.grid3}>
      <div>
        <label
          className={props.classLabel ? props.classLabel : mainTable.label}
        >
          {props.title}
          <span className={props.classStar ? props.classStar : "hidden"}>
            *
          </span>
        </label>
        <input
          ref={fileInputRef}
          className={props.Class ? props.Class : mainTable.input}
          name={props.name}
          type="file"
          onChange={handleFileChange}
          disabled={props.disabled}
          clear={props.clear}
          tabIndex={props.tabIndex}
         
          accept={ALLOWED_FORMATS.map((format) => {
            switch (format) {
              case "image/jpeg":
              case "image/jpg":
                return ".jpg,.jpeg";
              case "image/png":
                return ".png";
              case "application/pdf":
                return ".pdf";
              case "application/msword":
                return ".doc";
              case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                return ".docx";
              case "application/vnd.ms-excel":
                return ".xls";
              case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                return ".xlsx";
              case "application/vnd.ms-powerpoint":
                return ".ppt";
              case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                return ".pptx";
              default:
                return "";
            }
          }).join(",")}
        />
        <span className="text-red-500 text-xs whitespace-normal block">
          {props.limitMassage}
        </span>
        {(props.imageUploadedError || uploadError) && (
          <span className="text-red-500 whitespace-normal block">
            {props.imageUploadedError || uploadError}
          </span>
        )}
      </div>

      <div className="flex py-4 md:py-0">
        <div className="mt-7 mr-7">
          <button
            type="button"
            className={
              buttonDisable
                ? mainTable.disabledSubmitButton
                : mainTable.submitButton
            }
            onClick={handleUpload}
            disabled={buttonDisable}
          >
            UPLOAD
          </button>
        </div>

        {props.showImage && !cancelImage && (
          <div>
            <img
              onClick={() => {
                setSelectedFileUrl(props.showImage);
                setShowFileModal(true);
              }}
              src={getFileIcon(props.showImage)}
              alt="File preview"
              className="w-20 h-20 cursor-pointer"
            />
            {!props.disabledBtn && props.delete && (
              <button
                type="button"
                className="text-red-500 ml-4"
                onClick={handleCancel}
              >
                Delete
              </button>
            )}
          </div>
        )}

        {!props.showImage && props.imageShow !== false && (
          <img
            src={download}
            alt="Preview"
            className="rounded-full w-20 h-20"
          />
        )}

        {showFileModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => setShowFileModal(false)}
          >
            <div
              className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setShowFileModal(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
              >
                ✕
              </button>
              {selectedFileUrl ? (
                isImageFile(selectedFileUrl) ? (
                  <img
                    src={selectedFileUrl}
                    alt="Preview"
                    className="w-full h-full object-contain rounded"
                  />
                ) : (
                  <>
                    <img
                      src={getFileIcon(selectedFileUrl)}
                      alt="File icon"
                      className="w-20 h-20 mx-auto"
                    />
                    <iframe
                      src={getViewerUrl(selectedFileUrl)}
                      title="File Viewer"
                      className="w-full h-[80vh] rounded mt-4"
                    />
                  </>
                )
              ) : (
                <div className="text-center text-gray-500">
                  No file selected
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

FileUpload.propTypes = {
  modalName: PropTypes.string.isRequired,
  apiCall: PropTypes.string.isRequired,
  showImageData: PropTypes.func,
  classDiv: PropTypes.string,
  showImage: PropTypes.string,
  classLabel: PropTypes.string,
  classStar: PropTypes.string,
  Class: PropTypes.string,
  partnerId: PropTypes.string,
  createdBy: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  clear: PropTypes.bool,
  tabIndex: PropTypes.number,
  MAX_FILE_SIZE_MB: PropTypes.number,
  ALLOWED_FORMATS: PropTypes.arrayOf(PropTypes.string),
  limitMassage: PropTypes.string,
  imageUploadedError: PropTypes.string,
  clearImageUploadError: PropTypes.func,
  disabledBtn: PropTypes.bool,
  delete: PropTypes.bool,
  imageShow: PropTypes.bool,
  onUploadStatus: PropTypes.func,
};
FileUpload.defaultProps = {
  delete: true,
};
export default FileUpload;
